/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/upload-1214659': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M8.71 7.71L11 5.41V15a1 1 0 002 0V5.41l2.29 2.3a1 1 0 001.42 0 1 1 0 000-1.42l-4-4a1 1 0 00-.33-.21 1 1 0 00-.76 0 1 1 0 00-.33.21l-4 4a1 1 0 101.42 1.42zM21 12a1 1 0 00-1 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6a1 1 0 00-2 0v6a3 3 0 003 3h14a3 3 0 003-3v-6a1 1 0 00-1-1z"/>'
  }
})
